import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

import { TokenStorage } from '@/app/core/services';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const token = inject(TokenStorage).get();

  if (token) {
    const authReq = request.clone({
      headers: request.headers.set('Authorization', 'Bearer ' + token),
    });

    return next(authReq);
  }

  return next(request);
};
